package com.wintermar.inspection.feature.domain.usecase.answer

import com.wintermar.inspection.core.domain.Result
import com.wintermar.inspection.core.ui.component.image.util.FileUploadStatus
import com.wintermar.inspection.feature.domain.repository.answer.AnswerFileRepository

class UpdateUploadStatusUseCase(
    private val answerFileRepository: AnswerFileRepository
) {
    suspend operator fun invoke(fileId: String, uploadStatus: FileUploadStatus): Result<Unit> {
        return answerFileRepository.updateUploadStatus(fileId, uploadStatus)
    }
}
